import React, { useEffect } from 'react'

import { useDispatch } from 'react-redux'

import { wsOnNewPost } from '../redux/messageBoard/actions'
import { wsOnNotification } from '../redux/notification/actions'

import ws from '../common/WebSocketClient'
import * as wsTypes from '../redux/ws/types'
import * as matchTypes from '../redux/match/types'

import auth from '../common/auth'


const Live = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        ws.connect().then(() => {
                
            ws.on('update', (obj) => { 
                const jobj = JSON.parse(obj);
                dispatch({ type : wsTypes.WS_MESSAGE, message : jobj.message, payload : jobj.payload });

            });

            ws.on('PostCreated', (obj) => {
                if (obj.user.id !== auth.getUserId()) {
                    dispatch(wsOnNewPost(obj.messageBoard.id, obj.parent && obj.parent.id, obj));
                }
            });

            ws.on('Notification', (obj) => {
                dispatch(wsOnNotification(obj));
            });

        })


        
    }, []);


    return null;
}


export default Live;

